import { render, staticRenderFns } from "./ErrorAlert.vue?vue&type=template&id=48b035c8&scoped=true"
import script from "./ErrorAlert.vue?vue&type=script&lang=js"
export * from "./ErrorAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b035c8",
  null
  
)

export default component.exports